import MyDocuments from "../sections/MyDocuments";
import SharedDocuments from "../sections/SharedDocuments";
import MissionDocuments from "../sections/MissionDocuments";
import SharedWithMeDocuments from "../sections/SharedWithMeDocuments";

export const getTabSections = (tabIndex: number) => {
    switch (tabIndex) {
        case 0:
            return <MyDocuments />;
        case 1:
            return <SharedDocuments />;
        case 2:
            return <MissionDocuments />;
        case 3:
            return <SharedWithMeDocuments />;
        default:
            return null;
    }
};
